module.exports = __webpack_public_path__ + "static/media/Dlouhe_dily.9992b0ec.md";